module.exports = __webpack_public_path__ + "img/next.281812cc.svg";